var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLittleIconStateStripePending({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5.71387,
    r: 5,
    fill: "#FF9D00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.2998 1.81396V5.81396L8.2998 4.81396",
    stroke: "white",
    strokeWidth: 0.77
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLittleIconStateStripePending);
export default __webpack_public_path__ + "static/media/littleIconStateStripePending.3d72388138211edb231ea27d680cf573.svg";
export { ForwardRef as ReactComponent };